import React, { useState } from "react";
import { Card, Table, Modal, Form, Button, Dropdown } from "react-bootstrap";

const SLAPoliciesList = ({ showModal, closeModal,policies }) => {

  const [dummyPolicies, setDummyPolicies] = useState([
    {
      priority: "Critical",
      description: "System wide outage affecting all tenants",
      first: "1 Hour",
      resolution: "2 – 4 Hours",
      escalation: "1 hour",
      escalatesTo: "Support Lead"
    },
    {
      priority: "High",
      description: "Core module failure affecting primary workflow",
      first: "4 Hours",
      resolution: "8 Hours",
      escalation: "2 hours",
      escalatesTo: "Support Lead"
    },
    {
      priority: "Medium",
      description: "Minor issue affecting a limited user group",
      first: "8 Hours",
      resolution: "24 Hours",
      escalation: "4 hours",
      escalatesTo: "Support Team"
    },
    {
      priority: "Low",
      description: "Low impact problem affecting few users",
      first: "24 Hours",
      resolution: "1 - 2 Days",
      escalation: "6 hours",
      escalatesTo: "Support Team"
    }
  ]);

  const [form, setForm] = useState({
    priority: "",
    description: "",
    first: "",
    resolution: "",
    escalation: "",
    escalatesTo: ""
  });

  const allPolicies = policies.length ? policies : dummyPolicies;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

//   const addPolicy = () => {
//    setDummyPolicies([...policies, form]);

//     setForm({
//       priority: "",
//       description: "",
//       first: "",
//       resolution: "",
//       escalation: "",
//       escalatesTo: ""
//     });

//     closeModal();
//   };

  return (
    <>
      <Card  style={{ backgroundColor: "rgb(255 255 255)" }}>

<Card.Header
  style={{ backgroundColor: "rgb(255 255 255)" }}
  className="d-flex justify-content-between flex-wrap align-items-center"
>

  <h5 className="mb-2">SLA Policies List</h5>

  <div className="d-flex flex-wrap gap-2">

    <Dropdown>
      <Dropdown.Toggle
        className="border p-2"
        size="sm"
        variant="light"
      >
        Select Priority
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item>Critical</Dropdown.Item>
        <Dropdown.Item>High</Dropdown.Item>
        <Dropdown.Item>Medium</Dropdown.Item>
        <Dropdown.Item>Low</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>

    <Dropdown>
      <Dropdown.Toggle
        className="border p-2"
        size="sm"
        variant="light"
      >
        Sort By : Last 7 Days
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item>Recently Added</Dropdown.Item>
        <Dropdown.Item>Ascending</Dropdown.Item>
        <Dropdown.Item>Descending</Dropdown.Item>
        <Dropdown.Item>Last Month</Dropdown.Item>
        <Dropdown.Item>Last 7 Days</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>

  </div>

</Card.Header>

        <Card.Body className="p-0">

          <Table responsive hover className="mb-0">

            <thead className="table-light">
              <tr>
                <th><Form.Check /></th>
                <th>Priority</th>
                <th>Description</th>
                <th>First Response Time</th>
                <th>Resolution Time</th>
                <th>Escalation Time</th>
                <th>Escalates To</th>
              </tr>
            </thead>

            <tbody>

              {allPolicies.map((item, i) => (
                <tr key={i}>
                  <td><Form.Check /></td>
                  <td className="fw-semibold">{item.priority}</td>
                  <td>{item.description}</td>
                  <td>{item.first}</td>
                  <td>{item.resolution}</td>
                  <td>{item.escalation}</td>
                  <td>{item.escalatesTo}</td>
                </tr>
              ))}

            </tbody>

          </Table>

        </Card.Body>
      </Card>


      {/* MODAL */}

      <Modal show={showModal} onHide={closeModal} centered>

        <Modal.Header closeButton>
          <Modal.Title>Add Policy</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <Form>

            <Form.Group className="mb-3">
              <Form.Label>Policy</Form.Label>
              <Form.Control
                name="priority"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>First Response Time</Form.Label>
              <Form.Select name="first" onChange={handleChange}>
                <option>Select</option>
                <option>1 Hour</option>
                <option>4 Hours</option>
                <option>8 Hours</option>
                <option>24 Hours</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Resolution Time</Form.Label>
              <Form.Select name="resolution" onChange={handleChange}>
                <option>Select</option>
                <option>2 – 4 Hours</option>
                <option>8 Hours</option>
                <option>24 Hours</option>
                <option>1 - 2 Days</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Escalation Time</Form.Label>
              <Form.Select name="escalation" onChange={handleChange}>
                <option>Select</option>
                <option>1 hour</option>
                <option>2 hours</option>
                <option>4 hours</option>
                <option>6 hours</option>
              </Form.Select>
            </Form.Group>

            <Form.Group>
              <Form.Label>Escalates To</Form.Label>
              <Form.Select name="escalatesTo" onChange={handleChange}>
                <option>Select</option>
                <option>Support Lead</option>
                <option>Support Team</option>
              </Form.Select>
            </Form.Group>

          </Form>

        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>

          <Button
            style={{
              background: "#ff6a00",
              border: "none"
            }}
          //   onClick={addPolicy}
          >
            Add Policy
          </Button>

        </Modal.Footer>

      </Modal>
  <style>
  {`
    .form-check-input:checked {
      background-color: #f26522;
      border-color: #f26522;
    }
      .dropdown-item:hover {
  background-color: #f26522;
  color: #fff;
}
  `}
  </style>

    </>
  );
};

export default SLAPoliciesList;